export default {
  isTransactionSuccess: (state) => state.isSucceeded,

  permissionsByRole: (state) => state.permissionList,
  getRolePermissions: (state) => () => {
    let permissions = state.role?.permissions || [];
    return permissions.map((obj) => obj.id);
  },
  getErrors: (state) => () => {
    return {
      errorMessage: state.errorMessage,
      validationErrors: state.validationErrors,
    };
  },

  getAllRoles: (state) => state.allRolesResponse?.data || [],
};
